'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClickAwayListener = require('@material-ui/core/ClickAwayListener');

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

var _SearchBarTag = require('./searchBarComponents/SearchBarTag');

var _SearchBarTag2 = _interopRequireDefault(_SearchBarTag);

var _AdvancedSearch = require('./searchBarComponents/AdvancedSearch');

var _AdvancedSearch2 = _interopRequireDefault(_AdvancedSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Search = function Search() {
  return _react2.default.createElement(
    'svg',
    { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 512 512' },
    _react2.default.createElement('path', { d: 'M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z' })
  );
};

var CaretDown = function CaretDown() {
  return _react2.default.createElement(
    'svg',
    { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 320 512' },
    _react2.default.createElement('path', { d: 'M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z' })
  );
};

var Close = function Close() {
  return _react2.default.createElement(
    'svg',
    { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 320 512' },
    _react2.default.createElement('path', { d: 'M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z' })
  );
};

var SearchBar = function (_PureComponent) {
  _inherits(SearchBar, _PureComponent);

  function SearchBar(props) {
    var _this2 = this;

    _classCallCheck(this, SearchBar);

    var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));

    _this.state = {
      searchValue: '',
      selectedTagIndex: null,
      onKeyDownSelectedTagActive: true,
      expandedAdvancedSearch: false,
      advancedSearchIsActive: false,
      dom: null
    };

    _this.cleanInputValue = function (inputValue) {
      var _this$props = _this.props,
          autoHashtag = _this$props.autoHashtag,
          autoAt = _this$props.autoAt;

      var prefix = ['+', '-', '@', '#'];
      var wrapper = ['"'];

      var value = inputValue.trim();

      if (value === "") return value;

      var prefixIndex = prefix.indexOf(value[0]);
      var wrapperIndex = wrapper.indexOf(value[0]);

      if (prefixIndex !== -1) return '' + prefix[prefixIndex] + value.substr(1, value.length - 1).trim();
      if (wrapperIndex !== -1) {
        if (value[0] === value[value.length - 1]) return '' + wrapper[wrapperIndex] + value.substr(1, value.length - 2).trim() + wrapper[wrapperIndex];else return '' + wrapper[wrapperIndex] + value.substr(1, value.length - 1).trim() + wrapper[wrapperIndex];
      }
      if (autoHashtag) return '#' + value;
      if (autoAt) return '#' + value;
      return value;
    };

    _this.addTag = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props2, tags, onChange, onlyHashtagOrAt, searchValue, tag, newTags;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, tags = _this$props2.tags, onChange = _this$props2.onChange, onlyHashtagOrAt = _this$props2.onlyHashtagOrAt;
              searchValue = _this.state.searchValue;
              tag = _this.cleanInputValue(searchValue);

              //clear search value

              _this.setState({ searchValue: '' });

              // avoid empty tags

              if (!(tag === '')) {
                _context.next = 6;
                break;
              }

              return _context.abrupt('return');

            case 6:
              if (!(onlyHashtagOrAt && tag[0] !== '@' && tag[0] !== '#')) {
                _context.next = 8;
                break;
              }

              return _context.abrupt('return');

            case 8:
              newTags = [].concat(_toConsumableArray(tags), [tag]);

              onChange({ tags: newTags, tag: tag, action: 'addition' });

              _this.setState({ advancedSearchIsActive: false });

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.updateSearchValue = function (_ref2) {
      var searchValue = _ref2.value;


      _this.setState({ selectedTagIndex: null });
      if (searchValue[searchValue.length - 1] === ',') {
        _this.addTag();
      } else _this.setState({ searchValue: searchValue });
    };

    _this.deleteTag = function (tagIndex) {
      var _this$props3 = _this.props,
          tags = _this$props3.tags,
          onChange = _this$props3.onChange;

      var newTags = tags.filter(function (tag, index) {
        return index !== tagIndex;
      });

      var deletedTag = tags[tagIndex];
      onChange({ tags: newTags, tag: deletedTag, action: 'deletion' });

      _this.setState({ advancedSearchIsActive: false });
    };

    _this.deleteAllTags = function () {
      _this.props.onChange({ tags: [], action: "deleteAll" });
      _this.setState({ advancedSearchIsActive: false });
    };

    _this.onKeyPress = function (_ref3) {
      var key = _ref3.key,
          event = _ref3.event;
      var _this$props4 = _this.props,
          tags = _this$props4.tags,
          selectable = _this$props4.selectable;
      var _this$state = _this.state,
          searchValue = _this$state.searchValue,
          selectedTagIndex = _this$state.selectedTagIndex;

      // Force focus on tab if tags

      if (key === 'Tab') {
        if (searchValue.length > 0) event.preventDefault();
        _this.addTag();
        return;
      }

      if (key === 'ArrowLeft' && selectable && searchValue === '' && selectedTagIndex === null) {
        _this.setState({ selectedTagIndex: tags.length - 1, onKeyDownSelectedTagActive: false });
      }

      if (key === 'ArrowRight' && selectable && searchValue === '' && selectedTagIndex === null) {
        _this.setState({ selectedTagIndex: 0, onKeyDownSelectedTagActive: false });
      }

      if (key === 'Backspace' && searchValue === '' && tags.length > 0 && (selectedTagIndex === null || selectedTagIndex < 0 || selectedTagIndex >= tags.length)) {
        _this.deleteTag(tags.length - 1);
      }
    };

    _this.activateOnKeyDownSelectedTag = function () {
      _this.setState({ onKeyDownSelectedTagActive: true });
    };

    _this.handleDeleteTag = function (index) {
      return function () {
        return _this.deleteTag(index);
      };
    };

    _this.handleUpdateTag = function (index) {
      return function (value) {
        return _this.updateTag(value, index);
      };
    };

    _this.updateTag = function (value, tagIndex) {
      var _this$props5 = _this.props,
          tags = _this$props5.tags,
          onChange = _this$props5.onChange;


      var newTag = _this.cleanInputValue(value);
      var newTags = tags.map(function (tag, index) {
        return index === tagIndex ? newTag : tag;
      });
      var updatedTag = tags[tagIndex];
      onChange({ tags: newTags, tag: updatedTag, action: 'edition' });
      _this.setState({ advancedSearchIsActive: false });
    };

    _this.toggleAdvancedSearch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this$state2, expandedAdvancedSearch, advancedSearchIsActive, searchValue, onToggleAdvancedSearch;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$state2 = _this.state, expandedAdvancedSearch = _this$state2.expandedAdvancedSearch, advancedSearchIsActive = _this$state2.advancedSearchIsActive, searchValue = _this$state2.searchValue;
              onToggleAdvancedSearch = _this.props.onToggleAdvancedSearch;

              if (!(searchValue !== '')) {
                _context2.next = 5;
                break;
              }

              _context2.next = 5;
              return _this.addTag();

            case 5:

              if (!expandedAdvancedSearch && !advancedSearchIsActive) {
                _this.setState({ advancedSearchIsActive: true });
              }
              _this.setState({ expandedAdvancedSearch: !expandedAdvancedSearch });
              if (onToggleAdvancedSearch) onToggleAdvancedSearch({ active: !expandedAdvancedSearch });

            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));
    _this.handleClickAway = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var activeOnBlur, _this$state3, expandedAdvancedSearch, searchValue;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              activeOnBlur = _this.props.activeOnBlur;
              _this$state3 = _this.state, expandedAdvancedSearch = _this$state3.expandedAdvancedSearch, searchValue = _this$state3.searchValue;

              if (expandedAdvancedSearch) {
                _context3.next = 7;
                break;
              }

              if (!(activeOnBlur && searchValue !== '')) {
                _context3.next = 6;
                break;
              }

              _context3.next = 6;
              return _this.addTag();

            case 6:
              return _context3.abrupt('return');

            case 7:
              _this.toggleAdvancedSearch();

            case 8:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    _this.doAdvancedSearch = function (tags) {
      _this.setState({ advancedSearchIsActive: false, expandedAdvancedSearch: false });
      _this.props.onChange({ tags: tags, action: 'advancedSearch' });
    };

    _this.renderSearchBar = function () {
      var _this$props6 = _this.props,
          tags = _this$props6.tags,
          displaySearchButton = _this$props6.displaySearchButton,
          disabled = _this$props6.disabled,
          editable = _this$props6.editable,
          selectable = _this$props6.selectable,
          autoFocus = _this$props6.autoFocus,
          onlyHashtagOrAt = _this$props6.onlyHashtagOrAt,
          highlightWords = _this$props6.highlightWords,
          displayPlaceholder = _this$props6.displayPlaceholder,
          displayRemoveButton = _this$props6.displayRemoveButton,
          advancedSearch = _this$props6.advancedSearch,
          lexique = _this$props6.lexique;
      var _this$state4 = _this.state,
          expandedAdvancedSearch = _this$state4.expandedAdvancedSearch,
          searchValue = _this$state4.searchValue,
          selectedTagIndex = _this$state4.selectedTagIndex,
          onKeyDownSelectedTagActive = _this$state4.onKeyDownSelectedTagActive;


      return _react2.default.createElement(
        'div',
        { className: 'search-bar-flex-container' },
        displaySearchButton && _react2.default.createElement(
          'button',
          { className: 'search-bar-button-search', disabled: disabled, onClick: _this.addTag },
          _react2.default.createElement(Search, null)
        ),
        _react2.default.createElement(
          'div',
          { className: 'search-bar-tags-container' },
          !expandedAdvancedSearch && tags.map(function (tag, index) {
            return _react2.default.createElement(_SearchBarTag2.default, {
              value: tag,
              key: index,
              editable: editable,
              selectable: selectable,
              onArrowKey: _this.onArrowKeySelectedTag,
              onChangeSelectedTag: _this.onChangeSelectedTag(index),
              isSelected: selectedTagIndex === null ? null : selectable && selectedTagIndex === index,
              disabled: disabled,
              autoFocus: autoFocus,
              onlyHashtagOrAt: onlyHashtagOrAt,
              highlightWords: highlightWords,
              deleteTag: _this.handleDeleteTag(index),
              updateTag: _this.handleUpdateTag(index),
              index: index,
              myRef: _this.myRef,
              onKeyDownSelectedTagActive: onKeyDownSelectedTagActive,
              activateOnKeyDownSelectedTag: _this.activateOnKeyDownSelectedTag
            });
          }),
          _react2.default.createElement(_Input2.default, {
            noOutline: true,
            autoFocus: autoFocus,
            value: searchValue,
            onChange: _this.updateSearchValue,
            disabled: disabled || expandedAdvancedSearch,
            onEnterPress: _this.addTag,
            onKeyPress: _this.onKeyPress
          }),
          (expandedAdvancedSearch || displayPlaceholder && tags.length === 0 && searchValue === '') && _react2.default.createElement(
            'div',
            { className: 'search-bar-placeholder' },
            lexique.placeholder
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'search-bar-flex-buttons-wrapper' },
          displayRemoveButton && tags.length > 0 && !expandedAdvancedSearch && _react2.default.createElement(
            'button',
            { className: 'search-bar-button-delete-tags', onClick: _this.deleteAllTags },
            _react2.default.createElement(Close, null)
          ),
          advancedSearch && _react2.default.createElement(
            'button',
            { className: 'search-bar-button-display-advanced-search ' + (expandedAdvancedSearch ? 'search-bar-button-display-advanced-search--rotate' : ''), onClick: _this.toggleAdvancedSearch },
            _react2.default.createElement(CaretDown, null)
          )
        )
      );
    };

    _this.onChangeSelectedTag = function (index) {
      return function (isSelected) {
        var selectedTagIndex = isSelected ? index : null;
        _this.setState({ selectedTagIndex: selectedTagIndex });
      };
    };

    _this.onArrowKeySelectedTag = function (direction) {
      var tags = _this.props.tags;
      var selectedTagIndex = _this.state.selectedTagIndex;


      if (direction === 'left') {
        if (selectedTagIndex === 0) {
          _this.setState({ selectedTagIndex: tags.length - 1 });
        } else {
          _this.setState({ selectedTagIndex: selectedTagIndex - 1 });
        }
      }

      if (direction === 'right') {
        if (selectedTagIndex === tags.length - 1) {
          _this.setState({ selectedTagIndex: 0 });
        } else {
          _this.setState({ selectedTagIndex: selectedTagIndex + 1 });
        }
      }
    };

    _this.onRef = function (ref) {
      if (!_this.state.dom) _this.setState({ dom: ref });
    };

    _this.myRef = _react2.default.createRef();
    return _this;
  }

  /*
  ** advanced search
  */

  /*
  ** Render functions
  */

  _createClass(SearchBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          advancedSearch = _props.advancedSearch,
          autoFocus = _props.autoFocus,
          disabled = _props.disabled,
          tags = _props.tags,
          lexique = _props.lexique,
          filters = _props.filters,
          onChangeFilters = _props.onChangeFilters;
      var _state = this.state,
          expandedAdvancedSearch = _state.expandedAdvancedSearch,
          advancedSearchIsActive = _state.advancedSearchIsActive;


      return _react2.default.createElement(
        'div',
        { className: 'search-bar', ref: this.myRef },
        advancedSearch && _react2.default.createElement('div', { className: expandedAdvancedSearch ? 'search-bar-backdrop' : 'search-bar-backdrop--hidden' }),
        _react2.default.createElement(
          _ClickAwayListener2.default,
          { onClickAway: this.handleClickAway },
          _react2.default.createElement(
            'div',
            null,
            this.renderSearchBar(),
            advancedSearch ? _react2.default.createElement(_AdvancedSearch2.default, {
              autoFocus: autoFocus,
              disabled: disabled,
              expandedAdvancedSearch: expandedAdvancedSearch,
              advancedSearchIsActive: advancedSearchIsActive,
              tags: tags,
              doAdvancedSearch: this.doAdvancedSearch,
              cleanInputValue: this.cleanInputValue,
              toggleAdvancedSearch: this.toggleAdvancedSearch,
              lexique: lexique,
              filters: filters,
              onChangeFilters: onChangeFilters
            }) : null
          )
        )
      );
    }
  }]);

  return SearchBar;
}(_react.PureComponent);

SearchBar.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  tags: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  onlyHashtagOrAt: _propTypes2.default.bool,
  autoHashtag: _propTypes2.default.bool,
  autoAt: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  autoFocus: _propTypes2.default.bool,
  highlightWords: _propTypes2.default.arrayOf(_propTypes2.default.string),
  editable: _propTypes2.default.bool,
  selectable: _propTypes2.default.bool,
  displaySearchButton: _propTypes2.default.bool,
  displayPlaceholder: _propTypes2.default.bool,
  displayRemoveButton: _propTypes2.default.bool,
  advancedSearch: _propTypes2.default.bool,
  filters: _propTypes2.default.array
};

SearchBar.defaultProps = {
  onlyHashtagOrAt: false,
  autoHashtag: false,
  autoAt: false,
  disabled: false,
  autoFocus: true,
  highlightWords: ['name'],
  editable: true,
  selectable: true,
  displaySearchButton: true,
  displayPlaceholder: false,
  displayRemoveButton: true,
  advancedSearch: true,
  filters: []
};

exports.default = SearchBar;